import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { createProjectRequested } from './redux/actions';
import {
    createProjectLoading,
    createProjectSuccess,
    getResearchError,
} from './redux/selectors';
import FormInput from '../../common/FormInput';
import IconFolder from '../../icons/folder.svg';
import IconFile from '../../icons/file.svg';
import { TextField } from '@material-ui/core';
import { Modal } from 'react-bootstrap';
import './styles.scss';
import { noop } from '../../common/propTypes';

function AddPlacesModal({
    open,
    handleClose,
    createProject,
    isProcessing,
    createProjectSuccess,
    addedError,
}) {
    const [error, setError] = useState('');
    const [projectName, setProjectName] = useState('');
    const [postUploadText, setPostUploadText] = useState('');
    const [file, setFile] = useState(null);

    useEffect(() => {
        setError('');
        setFile(null);
        setPostUploadText('');
    }, [open]);

    useEffect(() => {
        if (!isProcessing && open) {
            if (createProjectSuccess) {
                setPostUploadText('Upload Successful');
                handleCloseOp();
            } else {
                setPostUploadText('');
                if (addedError) {
                    const invalidText = !Array.isArray(addedError)
                        ? addedError
                        : addedError.map((s, index) => (
                              <li key={index}>{s}</li>
                          ));
                    setError(
                        <span className="error-root custom-scroll">
                            <strong>
                                Please correct the errors and try again:
                            </strong>
                            {invalidText}
                        </span>,
                    );
                }
            }
        }
    }, [isProcessing]);

    const handleCloseOp = () => {
        setTimeout(handleClose, 1000);
    };

    return (
        <Modal
            show={open}
            onHide={noop}
            className={'create-partner-modal'}
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
            centered={true}
            animation={true}
        >
            {/* Modal code starts here */}
            <div className="modal-body add-places-modal">
                <div className="row">
                    <div className="col">
                        <form
                            onSubmit={(e) => {
                                e.preventDefault();
                            }}
                        >
                            <div className="row">
                                <div className="col-12">
                                    <h3>Create Project and Add Locations</h3>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12 mt-4">
                                    <FormInput
                                        title={'Create a Project'}
                                        bootstrapIcon={IconFolder}
                                        stylesIcon={{
                                            justifyContent: 'center',
                                        }}
                                    >
                                        <TextField
                                            type={'text'}
                                            placeholder={'Type Project Name'}
                                            onChange={(e) =>
                                                setProjectName(e.target.value)
                                            }
                                        />
                                    </FormInput>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-8">
                                    <FormInput
                                        title={'Select File (CSV)'}
                                        bootstrapIcon={IconFile}
                                        stylesIcon={{
                                            justifyContent: 'center',
                                        }}
                                        bottomtext={error}
                                    >
                                        <TextField
                                            type={'text'}
                                            required={true}
                                            placeholder={'Select File'}
                                            value={file ? file.name : ''}
                                            disabled={true}
                                        />
                                    </FormInput>
                                </div>
                                <div className="col-4">
                                    <input
                                        id="browse-research-csv"
                                        type="file"
                                        className="hidden"
                                        onChange={(e) => {
                                            const file = e.target.files[0];
                                            if (file) {
                                                if (
                                                    !file.name.endsWith('.csv')
                                                ) {
                                                    setError(
                                                        'File type must be csv',
                                                    );
                                                } else {
                                                    setError('');
                                                    setPostUploadText('');
                                                    setFile(file);
                                                }
                                            }
                                        }}
                                    />
                                    <button
                                        onClick={() => {
                                            const browseBtn = document.getElementById(
                                                'browse-research-csv',
                                            );
                                            browseBtn.click();
                                        }}
                                        className="btn btn-custom browse-btn mt-4"
                                    >
                                        Browse
                                    </button>
                                </div>
                            </div>
                            <div className="row">
                                <label className="post-add-text">
                                    {postUploadText}
                                </label>
                            </div>
                            <div className="row">
                                <div className="col-12 mb-2">
                                    <a
                                        href={
                                            process.env.API_URL +
                                            '/locations-import-template.csv'
                                        }
                                    >
                                        CSV Template
                                    </a>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12">
                                    <p>
                                        This tool will create a new research
                                        Project, with a Location and an
                                        unassigned Task for each line in the CSV
                                        file. By default, all Tasks will
                                        automatically require two Segments.
                                    </p>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12">
                                    <button
                                        disabled={!file || !projectName}
                                        onClick={() => {
                                            if (!isProcessing) {
                                                createProject(
                                                    projectName,
                                                    file,
                                                );
                                            }
                                        }}
                                        className="btn btn-custom btn-process mt-4"
                                    >
                                        {isProcessing
                                            ? 'Processing'
                                            : 'Import Locations File'}
                                    </button>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12">
                                    <button
                                        onClick={handleClose}
                                        className="btn btn-custom btn-reset mt-4"
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </Modal>
    );
}

AddPlacesModal.propTypes = {
    open: PropTypes.bool,
    handleClose: PropTypes.func,
    createProject: PropTypes.func,
    isProcessing: PropTypes.bool,
    createProjectSuccess: PropTypes.bool,
    addedError: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
};

AddPlacesModal.defaultProps = {
    open: false,
    handleClose: noop,
};

const mapStateToProps = (state) => {
    return {
        isProcessing: createProjectLoading(state),
        createProjectSuccess: createProjectSuccess(state),
        addedError: getResearchError(state),
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        createProject: (name, file) =>
            dispatch(createProjectRequested(name, file)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddPlacesModal);
